import { Header, Screen, Icon, Memories } from '@components'
//import { usePaginateMemories } from '@hooks'
import { useNavigation, useRoute, useTheme } from '@react-navigation/native'
import { NativeStackNavigationProp } from '@react-navigation/native-stack'
import { Theme } from '@theme'
import React, { useState } from 'react'
import {
  StyleSheet,
  TouchableOpacity,
  View,
} from 'react-native'
import { ProfileStackParamList } from 'src/navigation/navigator/ProfileNavigator'
import { useLanguage } from '@context'

export const MyMemories: React.FC = (): React.ReactElement => {
  const navigation = useNavigation<NativeStackNavigationProp<ProfileStackParamList, 'ProfileMemories'>>()
  const route = useRoute<any>()
  const profileId = route.params?.profileId
  const isMe = profileId === "me"
   
  const theme = useTheme()
  const { t } = useLanguage()
  const styles = getStyle(theme)

  //const { data, isPending, fetchNextPage } = usePaginateMemories()
  //const memories = data?.pages.flatMap((page) => page.data) || []

   const [isTagged, setIsTagged] = useState(false)

  /*const handleScroll = async (event: NativeSyntheticEvent<NativeScrollEvent>) => {
    const { layoutMeasurement, contentOffset, contentSize } = event.nativeEvent

    const isCloseToBottom = layoutMeasurement.height + contentOffset.y >= contentSize.height - 20
    if (isCloseToBottom) {
      await fetchNextPage()
    }
  }*/

  return (
    <Screen /*isPending={isPending}*/>
      <Header
        iconLeft="arrowBack"
        iconRight="plus"
        iconColor={theme.colors.secondary}
        onPressLeft={() => navigation.goBack()}
        onPressRight={() => navigation.navigate('ProfileAddMemory', isMe? {} : {selectedContacts: [profileId]})}
        title={t('memoriesForm.memory')}
      />
      <View style={styles.buttonsContainer}>
        <TouchableOpacity style={styles.categoryButton}  onPress={() => setIsTagged(false)}>
          <Icon 
            name="pictures" 
            size={25} 
            color={isTagged? theme.colors.greyBlue : theme.colors.primary}
            containerStyle={styles.categoryIcon}
          />
          {/*<Text type="bodySmall" color={isTagged? theme.colors.greyBlue : theme.colors.primary}>
            {isMe? "Mes p" : "P"}hotos
          </Text>*/}
        </TouchableOpacity>
        <TouchableOpacity style={styles.categoryButton} onPress={() => setIsTagged(true)}>
          <Icon 
            name="people" 
            size={25} 
            color={isTagged? theme.colors.primary : theme.colors.greyBlue}
            containerStyle={styles.categoryIcon}
          />
          {/*<Text type="bodySmall" color={isTagged? theme.colors.primary : theme.colors.greyBlue}>
            {isMe? "Mes i" : "I"}dentifications
          </Text>*/}
        </TouchableOpacity>
      </View>
      <Memories profileId={profileId} />
    </Screen>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    container: {
      paddingVertical: theme.spacing.lg,
      flex: 1,
    },
    buttonsContainer: {
      flexDirection: 'row',
      justifyContent: 'space-around',
      paddingHorizontal: theme.spacing.lg,
      paddingTop: theme.spacing.lg,
    },
    categoryButton: {
      alignItems: 'center',
      flex: 1,
    },
    categoryIcon: {
      marginBottom: theme.spacing.sm,
    },
    
  })
